export const resolveUrl = async (url: string): Promise<string> => {
  try {
    return (await fetch(url, { redirect: "follow" })).url;
  } catch (error) {
    return url;
  }
};
